import { inject, Inject, Injectable, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MoldFormDialogTypes } from './form.component';
import { Mold } from '../../../../api/elite/types/mold';
import { BehaviorSubject, Subscription } from 'rxjs';
import { ApiRouteMoldsService } from '../../../../api/elite/routes/molds.service';
import { map } from 'rxjs/operators';
import { MoldLocation } from '../../../../api/elite/types/mold-location';

@Injectable()
export class MoldDialogFormService implements OnDestroy {
  private readonly apiMoldLocationsRouter = inject(ApiRouteMoldsService);
  isEdit: boolean;
  private _selectedMold = new BehaviorSubject<Mold>(undefined);
  set selectedMold(val: Mold) {
    this._selectedMold.next(val);
  }

  selectedMold$ = this._selectedMold.asObservable();
  private selectedBasePlates = new BehaviorSubject<
    { id: number; title: string }[]
  >(undefined);
  selectedBasePlates$ = this.selectedBasePlates.asObservable();

  get molds(): Mold[] {
    return [...this.data.molds];
  }

  get selectedMoldValue(): Mold {
    return this._selectedMold.getValue();
  }

  private _basePlates: { id: number; title: string }[] = [];
  get basePlates(): { id: number; title: string }[] {
    return [...this._basePlates];
  }

  private _locations = new BehaviorSubject<{ id: number; title: string }[]>([]);
  locations$ = this._locations.asObservable();

  // showStepSelectionBasePlates$ = this._selectedMold
  //   .asObservable()
  //   .pipe(map((mold) => mold?.details?.type.title === 'Mold'));

  private subscription: Subscription;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    private readonly data: MoldFormDialogTypes['data']
  ) {
    this._basePlates = this.data.molds
      .filter((m) => m.details?.type.title === 'Base Plate')
      .map((m) => ({ id: m.id, title: m.name }));
    this.subscription = this._selectedMold.subscribe((mold) => {
      if (!mold) {
        this.selectedBasePlates.next([]);
        return;
      }
      const list = mold.details.relationsToBasePlates.map((m) => {
        const plate = this._basePlates.find((b) => b.id === m.basePlateId);
        return { id: plate.id, title: plate.title };
      });
      this.selectedBasePlates.next(list);
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  setMoldLocations(currentLocation?: MoldLocation): void {
    this.apiMoldLocationsRouter
      .locationsByDepartment(this.data.department)
      .pipe(
        map((res) => res.map((loc) => ({ id: loc.id, title: loc.fullName })))
      )
      .subscribe((res) => {
        if (!currentLocation) {
          this._locations.next(res);
          return;
        }
        const isInserted = res.find((el) => el.id === currentLocation.id);
        if (isInserted) {
          this._locations.next(res);
        } else {
          this._locations.next([
            ...res,
            { id: currentLocation.id, title: currentLocation.title },
          ]);
        }
      });
  }
}
